<template>
  <div :class="['mag-launcher', inactiveClass]"
       @click="onLearnMore">
    <div class="mag-launcher__row">
      <div class="mag-launcher__col">
        <div role="img"
             class="mag-launcher__img-wrapper"
             :aria-label="aria.cover.ariaLabel">
          <img loading="lazy"
               :src="coverSrc"
               :alt="aria.cover.ariaLabel">
        </div>
      </div>
      <div class="mag-launcher__col">
        <template v-if="isLoggedIn">
          <div class="mag-launcher__content">
            <h3>{{ title }}</h3>
            <p>{{ desc }}</p>
          </div>
          <div role="group"
               :aria-label="aria.controls.group.ariaLabel"
               class="mag-launcher__controls">
            <button v-if="isLoggedIn === false"
                    class="btn btn-accent-2"
                    @click="onLearnMore">
              {{ ui.controls.learnMore.text }}
            </button>
            <button class="btn btn-accent-1"
                    @click="onLaunchMagazine">
              {{ ui.controls.launchMagazine.text }}
            </button>
          </div>
        </template>
        <template v-else-if="siteLoggedIn">
          <span class="validation-error"
                style="white-space: pre-line;"
                v-html="magazineNoAccessText" />
        </template>
        <template v-else>
          <div class="mag-launcher__content">
            <h3>{{ title }} User Login</h3>
            <!-- eslint-disable vue/no-v-html -->
            <span v-if="!isLoggedIn"
                  class="validation-error"
                  v-html="magazineLoginFailedValidationText" />
            <!-- eslint-enable vue/no-v-html -->
            <login-form v-if="!siteLoggedIn"
                        :redirect-url="launchHref"
                        :username-label="null"
                        :password-label="null"
                        username-type="text"
                        username-placeholder="Username"
                        username-validation-message="Please enter a valid username."
                        :enable-password-visibility="enablePasswordVisibility"
                        :login-button-label="'Login to ' + title"
                        :disable-fields="siteLoggedIn && !isLoggedIn"
                        redirect
                        button-class="btn btn-accent-2 btn-icon">
            </login-form>

            <div class="mag-launcher__text">
              <!-- eslint-disable vue/no-v-html -->
              <span style="white-space: pre-line"
                    v-html="magazineForgottenLoginText" />
              <!-- eslint-enable vue/no-v-html -->
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import { LoginForm } from "spiritweb.packages.web-account";

export default {
  name: "MagazineLauncher",
  components: {
    LoginForm,
  },
  props: {
    type: {
      type: String,
      required: true,
    },
    coverSrc: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    desc: {
      type: String,
      default: undefined,
    },
    launchHref: {
      type: String,
      required: true,
    },
    isInactive: {
      type: Boolean,
      default: false,
    },
    isLoggedIn: {
      type: Boolean,
      default: false,
    },
    siteLoggedIn: {
      type: Boolean,
      default: false,
    },
    enablePasswordVisibility: {
      type: Boolean,
      default: false,
    },
    magazineLoginFailedValidationText: {
      type: String,
      default: "Please use your Magazine Login, not your account login."
      + " You can check magazine login details in My Account area.",
    },
    magazineForgottenLoginText: {
      type: String,
      default: "Forgotten your logins? \n"
                + "Students: contact your teacher or librarian.\n"
                + "UK Educator Admin/Standard or Overseas: log in to your school portal (My Account) "
                + "and set a new username and password.\n"
                + "Teacher Home Address Only/Private Individual: use your main account logins.",
    },
    magazineNoAccessText: {
      type: String,
      default: "",
    },
  },
  data () {
    return {
      test: "string \n string \n\n\n\n\n string <br>",
    };
  },
  computed: {
    ui () {
      return {
        controls: {
          learnMore: {
            text: `Learn more about ${this.type}`,
          },
          launchMagazine: {
            text: `Launch ${this.type} online`,
          },
        },
      };
    },
    aria () {
      return {
        cover: {
          ariaLabel: `Magazine cover for ${this.type}. Titled: ${this.title}`,
        },
        controls: {
          group: {
            ariaLabel: "Magazine launcher controls",
          },
        },
      };
    },
    inactiveClass () {
      return {
        "mag-launcher--inactive": this.isInactive,
      };
    },
  },
  methods: {
    onLearnMore () {
      this.$emit( "learn-more" );
    },
    onLaunchMagazine () {
      window.location.href = this.launchHref;
    },
  },
};
</script>
<style scoped lang="less">
@import "../../Styles/utils/dimensions.less";
@import "../../Styles/utils/colors.less";

.mag-launcher + .mag-launcher {
  margin-left: 2rem;

  @media screen and (max-width: @wide-desktop) {
    margin-left: 0;
    margin-top: 2rem;
  }
}

.mag-launcher {
  max-width: 600px;
  min-height:400px;

  @media screen and (max-width: @wide-desktop) {
    flex: 1;
  }

  &--inactive {
    opacity: 0.5;
  }

  &__row {
    display: flex;
    flex-direction: row;

    @media screen and (max-width: @wide-desktop) {
      flex-direction: column;
    }
  }

  &__col {
    display: flex;
    flex-flow: column;
    justify-content: space-between;

    @media screen and (max-width: @wide-desktop) {
      flex: 1;
    }

    > img {
      width: 100%;
      height: 100%;
    }
  }

  .mag-launcher__col + .mag-launcher__col {
    margin-left: 1rem;

    @media screen and (max-width: @wide-desktop) {
      margin-left: 0;
      margin-top: 1rem;
    }
  }

  &__img-wrapper {
    width: 175px;

    > img {
      height: auto;
      width: 100%;
    }
  }

  &__content {
  }

  &__text {
    padding-top: 10px;
  }

  &__controls {
    display: flex;
    flex-flow: column;
    margin-top: auto;

    > button {
      width: 290px;
      white-space: nowrap;
    }

    > button + button {
      margin-top: 1rem;
    }
  }
}

/deep/ .form-control {
  border-top-left-radius: 8px !important;
  border-bottom-left-radius: 8px !important;

  + .form-control {
    margin: 16px 0 0;
  }
}

/deep/ .account-form__input-container {
  + .account-form__input-container {
    margin: 16px 0 0 ;
  }
}

/deep/ .submit-button__container {
  margin-top: 16px;
}

/deep/ .custom-checkbox,
/deep/ .input-group-prepend {
  display: none !important;
}
</style>
